import { Fragment } from "react";
import { ArrowRight, ArrowDown } from "lucide-react";

export const Flow = ({ items, dark = false, vertical = false, testid = "flow" }) => {
  const chip = dark
    ? "border-white/20 bg-white/5 text-white/85"
    : "border-[#0B132B]/15 bg-white text-[#0B132B]/80";
  const arrow = dark ? "text-[#14B8A6]" : "text-[#0D9488]";
  return (
    <div
      className={`flex ${vertical ? "flex-col items-start" : "flex-wrap items-center"} gap-2.5`}
      data-testid={testid}
    >
      {items.map((item, i) => (
        <Fragment key={item}>
          {i > 0 &&
            (vertical ? (
              <ArrowDown className={`ml-4 h-4 w-4 ${arrow}`} />
            ) : (
              <ArrowRight className={`h-3.5 w-3.5 shrink-0 ${arrow}`} />
            ))}
          <span
            className={`rounded-full border px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-[0.12em] ${chip}`}
          >
            {item}
          </span>
        </Fragment>
      ))}
    </div>
  );
};

export const Eyebrow = ({ children, dark = false }) => (
  <p
    className={`inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.24em] ${
      dark ? "text-[#14B8A6]" : "text-[#0D9488]"
    }`}
  >
    <span className={`h-px w-9 ${dark ? "bg-[#14B8A6]" : "bg-[#0D9488]"}`} />
    {children}
  </p>
);

export const PrimaryBtn = ({ to, children, testid, light = false }) => (
  <a
    href={to}
    data-testid={testid}
    className={`btn-sweep group inline-flex items-center justify-center gap-2.5 px-9 py-4 text-[13px] font-bold uppercase tracking-[0.14em] transition-colors duration-300 ${
      light
        ? "btn-sweep-white bg-[#14B8A6] text-[#06202A]"
        : "btn-sweep-navy bg-[#0D9488] text-white"
    }`}
  >
    {children}
    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
  </a>
);

export const GhostBtn = ({ to, children, testid, dark = false }) => (
  <a
    href={to}
    data-testid={testid}
    className={`btn-sweep inline-flex items-center justify-center gap-2 border px-9 py-4 text-[13px] font-bold uppercase tracking-[0.14em] transition-colors duration-300 ${
      dark
        ? "btn-sweep-glass border-white/30 text-white hover:border-white/70"
        : "btn-sweep-teal border-[#0B132B]/25 text-[#0B132B] hover:border-[#0D9488] hover:text-white"
    }`}
  >
    {children}
  </a>
);
